export default "__VITE_ASSET__CjXhwFgT__"